<form #form="ngForm">
    <div *ngIf="formulaireNdfService.paramNdf as paramNdf; else loading">
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.formulaire.ndf.parametrage'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="actif"
                            name="actif"
                            [ngModel]="paramNdf.actif"
                            [(customModel)]="paramNdf.actif"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.ndf.actif"
                            postLibelle="admin.parametres.formulaire.ndf.actifPost"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.formulaire.ndf.generalite'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="objetNDF"
                            name="objetNDF"
                            [(ngModel)]="paramNdf.objetNDF"
                            customType="input"
                            libelle="admin.parametres.formulaire.ndf.objetInitial"
                            [postTooltipNio]="{ content: objetTooltip }"
                    ></custom-input>
                </div>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="affichageMIB"
                            name="affichageMIB"
                            [ngModel]="paramNdf.affichageMIB"
                            [(customModel)]="paramNdf.affichageMIB"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.ndf.imputationBudgetaire"
                            postLibelle="admin.parametres.formulaire.ndf.imputationBudgetairePost"
                            (customModelChange)="onMIBChange(paramNdf)"
                    ></custom-input>
                    <custom-input
                            ngDefaultControl
                            id="noMIBDefaut"
                            name="noMIBDefaut"
                            [ngModel]="paramNdf.noMIBDefaut"
                            [(customModel)]="paramNdf.noMIBDefaut"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.ndf.moisImputation"
                            postLibelle="admin.parametres.formulaire.ndf.moisImputationPost"
                            [disabled]="!paramNdf.affichageMIB"
                    ></custom-input>
                </div>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="modeRestitutionNumero"
                            name="modeRestitutionNumero"
                            customType="select"
                            [(ngModel)]="paramNdf.modeRestitutionNumero"
                            [selectOptions]="modeRestitutionNumeroOptions"
                            libelle="admin.parametres.formulaire.ndf.numeroNoteDeFrais"
                            optionDisplay="libelle"
                            optionValue="value"
                    ></custom-input>
                    <custom-input
                            ngDefaultControl
                            id="nbRepartitions"
                            name="nbRepartitions"
                            [(ngModel)]="paramNdf.nbRepartitions"
                            customType="number"
                            libelle="admin.parametres.formulaire.ndf.nombreMaximumRepartitionAnalytique"
                            [postTooltip]="'admin.parametres.formulaire.ndf.nombreMaximumRepartitionAnalytiqueTooltip' | translate"
                            [min]="0"
                            [required]="true"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.formulaire.ndf.depensesControle'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="depenseNegative"
                            name="depenseNegative"
                            customType="select"
                            [(ngModel)]="paramNdf.depenseNegative"
                            [selectOptions]="controleOptions"
                            libelle="admin.parametres.formulaire.ndf.depensesNegatives"
                            optionDisplay="libelle"
                            optionValue="value"
                    ></custom-input>
                    <custom-input
                            ngDefaultControl
                            id="depenseFuture"
                            name="depenseFuture"
                            customType="select"
                            [(ngModel)]="paramNdf.depenseFuture"
                            [selectOptions]="controleOptions"
                            libelle="admin.parametres.formulaire.ndf.depensesFutures"
                            optionDisplay="libelle"
                            optionValue="value"
                    ></custom-input>
                </div>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="saisiePeriodeClosedForgotten"
                            name="saisiePeriodeClosedForgotten"
                            [ngModel]="paramNdf.saisiePeriodeClosedForgotten"
                            [(customModel)]="paramNdf.saisiePeriodeClosedForgotten"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.ndf.periodeNonOuverte"
                            postLibelle="admin.parametres.formulaire.ndf.periodeNonOuvertePost"
                    ></custom-input>
                    <custom-input
                            ngDefaultControl
                            id="depenseHorsMission"
                            name="depenseHorsMission"
                            customType="select"
                            [(ngModel)]="paramNdf.depenseHorsMission"
                            [selectOptions]="controleOptions"
                            libelle="admin.parametres.formulaire.ndf.depensesHorsMission"
                            optionDisplay="libelle"
                            optionValue="value"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.formulaire.ndf.fraisRefuse'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="rejetFrais"
                            name="rejetFrais"
                            [ngModel]="paramNdf.rejetFrais"
                            [(customModel)]="paramNdf.rejetFrais"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.ndf.refusIndividuel"
                            postLibelle="admin.parametres.formulaire.ndf.refusIndividuelpost"
                    ></custom-input>
                    <custom-input
                            ngDefaultControl
                            id="rejetFraisCloisonnement"
                            name="rejetFraisCloisonnement"
                            [ngModel]="paramNdf.rejetFraisCloisonnement"
                            [(customModel)]="paramNdf.rejetFraisCloisonnement"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.ndf.fraisRefuse"
                            postLibelle="admin.parametres.formulaire.ndf.fraisRefusePost"
                            [disabled]="!paramNdf.rejetFrais"
                    ></custom-input>
                </div>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="idMailRejetFrais"
                            name="idMailRejetFrais"
                            [(ngModel)]="paramNdf.idMailRejetFrais"
                            [selectOptions]="formulaireNdfService.messageNotificationListe"
                            customType="select"
                            libelle="admin.parametres.formulaire.ndf.notificationRejet"
                            optionDisplay="titre"
                            optionValue="idMessage"
                            [disabled]="!paramNdf.rejetFrais"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.formulaire.ndf.justificatifs'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="modeRestitutionJustificatif"
                            name="modeRestitutionJustificatif"
                            customType="select"
                            [(ngModel)]="paramNdf.modeRestitutionJustificatif"
                            [selectOptions]="modeRestitutionJustificatifOptions"
                            libelle="admin.parametres.formulaire.ndf.numeroJustificatif"
                            optionDisplay="libelle"
                            optionValue="value"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>
        <floating-button [listeActions]="listeActions" [isPending]="formulaireNdfService.isSaving"></floating-button>
    </div>
</form>

<!--Affiché si on a pas encore le modèle-->
<ng-template #loading>
    <please-wait class="content"></please-wait>
</ng-template>


<!-- Template du tooltip de l'objet -->
<ng-template #objetTooltip>
    <strong class="justify-content-center" translate>admin.parametres.formulaire.ndf.objetInitialTooltip.title</strong><br/>
    <table>
        <tr>
            <td><label translate>admin.parametres.formulaire.ndf.objetInitialTooltip.MM</label></td>
            <td translate>admin.parametres.formulaire.ndf.objetInitialTooltip.MMDetail</td>
        </tr>
        <tr>
            <td><label translate>admin.parametres.formulaire.ndf.objetInitialTooltip.MMM</label></td>
            <td translate>admin.parametres.formulaire.ndf.objetInitialTooltip.MMMDetail</td>
        </tr>
        <tr>
            <td><label translate>admin.parametres.formulaire.ndf.objetInitialTooltip.AA</label></td>
            <td translate>admin.parametres.formulaire.ndf.objetInitialTooltip.AADetail</td>
        </tr>
        <tr>
            <td><label translate>admin.parametres.formulaire.ndf.objetInitialTooltip.AAAA</label></td>
            <td translate>admin.parametres.formulaire.ndf.objetInitialTooltip.AAAADetail</td>
        </tr>
        <tr>
            <td><label translate>admin.parametres.formulaire.ndf.objetInitialTooltip.DD</label></td>
            <td translate>admin.parametres.formulaire.ndf.objetInitialTooltip.DDDetail</td>
        </tr>
        <tr>
            <td><label translate>admin.parametres.formulaire.ndf.objetInitialTooltip.NUM_INC</label></td>
            <td translate>admin.parametres.formulaire.ndf.objetInitialTooltip.NUM_INCDetail</td>
        </tr>
    </table>
</ng-template>
